// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"V_bv","reviews__wrapper__list":"V_dS","reviewSlider":"V_dT"};